module.exports = __webpack_public_path__ + "static/media/header_facebook_icon.020dd4a7.svg";